import React from 'react';
import { useSelector } from 'react-redux';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';
import { selectSingleAlert } from '../../../../redux/slices/singleAlertSlice/singleAlertSlice';
import AlertActionList from './AlertActionsList/AlertActionList';

function AlertActionsTabContent({
  dispatchModalAction,
  hasAdvancedAlerting,
}) {
  const activeAlert = useSelector(selectSingleAlert);

  return (
    <>
      <div>
        <AlertActionList
          dispatchModalAction={dispatchModalAction}
          hasAdvancedAlerting={hasAdvancedAlerting}
        />
        {
            (!hasAdvancedAlerting && activeAlert.alertActionList === 1)
            && (
            <div className="alert alert-info">
              <div className="float-left">
                <Icon icon="info-circle" />
              </div>
              <div style={{ marginLeft: '1.5em' }}>
                <p>Your current account allows one action for each alert.</p>
                <p>
                  For advanced functionality including
                  alerts that support multiple actions, repeat
                  notifications,
                  comments, customized alert messages and much more, consider
                  {' '}
                  <a href="/subscription">
                    upgrading
                  </a>
                  {' '}
                  your account.
                  {' '}
                  <a
                    type="button"
                    className="btn btn-sm btn-light border-info py-0"
                    href="/s/subscription/billing/change-plan"
                    style={{ lineHeight: '1' }}
                  >
                    Upgrade Now
                  </a>
                </p>
              </div>
            </div>
            )
        }
        {
            (!hasAdvancedAlerting && activeAlert.alertActionList.length > 1) && (
            <div className="alert alert-info">
              <div className="float-left">
                <Icon icon="info-circle" />
              </div>
              <div style={{ marginLeft: '1.5em' }}>
                <p>
                  {/* eslint-disable-next-line max-len */}
                  Your current account allows one action per alert.
                  Additional actions that may have been configured
                  were suspended when your account upgrade changed.
                  <br />
                  {/* eslint-disable-next-line max-len */}
                  For advanced functionality including alerts
                  that support multiple actions, repeat
                  notifications, customized alert messages and much more,
                  {/* eslint-disable-next-line max-len */}
                  consider upgrading your account.
                  Any suspended functionality remains in
                  place and will be restored once your account is upgraded.
                  {' '}
                  <a
                    type="button"
                    className="btn btn-sm btn-light border-info py-0"
                    href="/s/subscription/billing/change-plan"
                    style={{ lineHeight: '1' }}
                  >
                    Upgrade Now
                  </a>
                </p>
              </div>
            </div>
            )
        }
      </div>
    </>
  );
}

AlertActionsTabContent.propTypes = {
  users: PropTypes.shape({
    users: PropTypes.arrayOf(
      PropTypes.shape({
        userId: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
      }),
    ),
  }).isRequired,
  dispatchModalAction: PropTypes.func.isRequired,
  hasAdvancedAlerting: PropTypes.bool.isRequired,
};
export default AlertActionsTabContent;
